import { GroupRuleTimeInterval } from '@/models';

export const FALLBACK_LOCALE = 'en';
export const DAYS_IN_WEEK = 7;
export const REFERENCE_SUNDAY = new Date(2024, 0, 7);
export const ALL_WEEK_DAYS = [0, 1, 2, 3, 4, 5, 6];
export const ALL_DAY_START = '00:00';
export const ALL_DAY_END = '23:59';
export const MINUTES_IN_DAY = 24 * 60;
export const ALL_DAY_TIME_INTERVALS: GroupRuleTimeInterval[] = [
  { start: ALL_DAY_START, end: ALL_DAY_END },
];
